import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from '@elka/layout';
import { ThemeProvider } from '@elka/theme';
import './index.css';
// Import Firebase config to ensure it's initialized at startup
import './lib/firebase/config';
import { registerServiceWorker } from './lib/pwa/register';

console.log('🚀 CRM App Starting...');
console.log('Environment:', import.meta.env.MODE);
console.log('Dev mode:', import.meta.env.DEV);

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('❌ Root element not found!');
  throw new Error('Root element not found');
}

console.log('✅ Root element found, rendering app...');

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider storageKey="elka-theme" defaultTheme="elkaBlue">
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
);

registerServiceWorker();

console.log('✅ App rendered');
